import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeft = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("path", {
		d: "M16.25 23.25 5.53 12.53a0.749 0.749 0 0 1 0 -1.06L16.25 0.75",
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5
	}));
});
export default SvgArrowLeft;
